import { TableColumnsType } from 'antd';
import { DataCertificates } from 'store/ducks/Reportings/types';

export const certificateColumns: TableColumnsType<DataCertificates> = [
  {
    title: 'Certificate registry',
    width: 150,
    dataIndex: 'certificate_registry',
    key: 'certificate_registry',
  },
  {
    title: 'Date of certificate register',
    width: 150,
    dataIndex: 'date_of_certificate_register',
    key: 'date_of_certificate_register',
  },
  {
    title: 'Date of issuance',
    width: 150,
    dataIndex: 'date_of_issuance',
    key: 'date_of_issuance',
  },
  {
    title: 'Description',
    width: 150,
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: 'Certificate Valid to',
    width: 150,
    dataIndex: 'end_date',
    key: 'end_date',
  },
  {
    title: 'Ict service name',
    width: 150,
    dataIndex: 'ict_service_name',
    key: 'ict_service_name',
  },
  {
    title: 'Certificate Valid from',
    width: 150,
    dataIndex: 'start_date',
    key: 'start_date',
  },
  {
    title: 'Validity',
    width: 150,
    dataIndex: 'validity',
    key: 'validity',
  },
];
